module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"1":"Suggestions"},"en":{"1":"Suggestions"}}')
  delete Component.options._Ctor
}
